// BlockerActions.jsx — botões de ação sob uma system row com metadata.kind='turn_blocker'
// (DeerFlow borrow #1 follow-up). "Diga 'continue'" vira um clique: Continuar /
// Tentar de novo / Rodar verificação enviam o prompt via apolo:blockerAction
// (useBlockerActions no SessionWorkspace consome com dedup); Responder foca o composer.

import { blockerActionsFor } from '../../../lib/loop/blockerActions.js';

/** Dispara a ação de um botão (aqui e não no lib/loop: window é camada de UI). */
export function fireBlockerAction(action) {
  if (typeof window === 'undefined' || !action) return;
  if (action.focus) {
    window.dispatchEvent(new CustomEvent('apolo:focusComposer'));
    return;
  }
  if (!action.prompt) return;
  const nonce = `blk-${Date.now()}-${Math.random().toString(36).slice(2, 8)}`;
  window.dispatchEvent(new CustomEvent('apolo:blockerAction', {
    detail: { id: action.id, prompt: action.prompt, nonce },
  }));
}

export default function BlockerActions({ metadata }) {
  const actions = blockerActionsFor(metadata);
  if (actions.length === 0) return null;
  return (
    <div className="mt-1.5 flex flex-wrap gap-1.5">
      {actions.map((a) => (
        <button
          key={a.id}
          type="button"
          onClick={() => fireBlockerAction(a)}
          className="rounded-md border border-apolo-borderSubtle bg-apolo-surface2/50 px-2 py-0.5 text-[11px] text-apolo-textSecondary transition hover:border-apolo-borderStrong hover:bg-apolo-surface2 hover:text-apolo-textPrimary focus:outline-none focus-visible:ring-2 focus-visible:ring-apolo-accentRing"
        >
          {a.label}
        </button>
      ))}
    </div>
  );
}
